var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9 10C20.397 10 20.8 10.403 20.8 10.9C20.8 11.397 20.397 11.8 19.9 11.8C19.403 11.8 19 11.397 19 10.9C19 10.403 19.403 10 19.9 10Z",
    fill: "#263032"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9 12C18.397 12 18.8 12.403 18.8 12.9C18.8 13.397 18.397 13.8 17.9 13.8C17.403 13.8 17 13.397 17 12.9C17 12.403 17.403 12 17.9 12Z",
    fill: "#263032"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9 14C16.397 14 16.8 14.403 16.8 14.9C16.8 15.397 16.397 15.8 15.9 15.8C15.403 15.8 15 15.397 15 14.9C15 14.403 15.403 14 15.9 14Z",
    fill: "#263032"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9 16C14.397 16 14.8 16.403 14.8 16.9C14.8 17.397 14.397 17.8 13.9 17.8C13.403 17.8 13 17.397 13 16.9C13 16.403 13.403 16 13.9 16Z",
    fill: "#263032"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9 18C12.397 18 12.8 18.403 12.8 18.9C12.8 19.397 12.397 19.8 11.9 19.8C11.403 19.8 11 19.397 11 18.9C11 18.403 11.403 18 11.9 18Z",
    fill: "#263032"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9 16C10.397 16 10.8 16.403 10.8 16.9C10.8 17.397 10.397 17.8 9.9 17.8C9.403 17.8 9 17.397 9 16.9C9 16.403 9.403 16 9.9 16Z",
    fill: "#263032"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9 14C8.397 14 8.8 14.403 8.8 14.9C8.8 15.397 8.397 15.8 7.9 15.8C7.403 15.8 7 15.397 7 14.9C7 14.403 7.403 14 7.9 14Z",
    fill: "#263032"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.253e582964b3e6f8e156a7b7815e2843.svg";
export { ForwardRef as ReactComponent };